import NoSsr from '@mui/material/NoSsr';

export default NoSsr;
